import { trackPromise } from 'react-promise-tracker';
import { create } from 'zustand'
import { getNotificationStyle } from '../common/notification';
import {
    CustomerInterface,
    EventInterface,
    IAuthDataRequest,
    IBlockRequest,
    ICodeGenerator,
    IExtraData,
    IMasterInterface,
    IOwnerRequest,
    ISearchEmployeeRequest,
    IVehicleRequestbyId,
    IVehicleStatus,
    IVehicleTypeRequest,
} from '../model/MasterModel';
import {
    ActivateByIdService,
    CreateRequestService,
    DeActivateEmployeeByIdService,
    DeActivateExceptionByIdService,
    DeleteConsigneeByIdService,
    DeleteShipperByIdService,
    ExportAdhocEmployeeService,
    ExportAdhocVehiclesService,
    ExportEmployeeService,
    ExportNonAdhocEmployeeService,
    ExportNonAdhocVehiclesService,
    GetAdditonalPermitListService,
    GetAdhocEmployeesService,
    GetAdhocVehiclesService,
    GetBoxesHistoryByIdService,
    GetCategoryListService,
    GetCountryService,
    GetExceptionSubReasonService,
    GetListOfBoxesService,
    GetListOfTrayBarCodesService,
    GetNonAdhocEmployeesService,
    GetNonAdhocVehiclesService,
    GetOdaService,
    GetOdometerByIdService,
    GetOwnerListService,
    GetPlateAndFleetListService,
    GetRegionService,
    GetRequestByIdService,
    GetVehicleBodyTypeListService,
    GetVehicleBrandingListService,
    GetVehicleFuelTypeListService,
    GetVehicleGPSStatusListService,
    GetVehicleLeaseTypeListService,
    GetVehicleLoadTypeListService,
    GetVehicleMakeListService,
    GetVehicleModelListService,
    GetVehiclePurchaseModeListService,
    GetVehicleRequestFilesTypesListService,
    GetVehicleStatusByIdService,
    GetVehicleStatusListService,
    GetVehicleTypeListService,
    GetVehiclesLoggedInDetailsService,
    SaveAdditonalPermitService,
    SaveAuthDataService,
    SaveBarCodeGeneratorService,
    SaveOwnerService,
    SaveVehicleBodyTypeService,
    SaveVehicleBrandingService,
    SaveVehicleFuelTypeService,
    SaveVehicleLoadTypeService,
    SaveVehicleMakeService,
    SaveVehicleModelService,
    SaveVehiclePurchaseModeService,
    SaveVehicleReplacementService,
    SaveVehicleTypeService,
    SearchEmployeeService,
    SubAccountBlockByIdService,
    UpdateVehiclesLoggedInDetailsService,
    getAdhocVehiclesService,
    getCityListService,
    getCustomerListService,
    getEmployeeListService,
    getEventListService,
    getExceptionListService,
    getTripRouteListService,
    getVehicleListService,
    getOtherSellerTypeListService,
    GetTripRouteByIdService,
    ExportTripRoutesExcelService
} from '../services/master-services';
import { ICityResponse, ICountryResponse, IEventResponse, IExceptionResponse, IMasterInitial, IOdaResponse, IProductResponse, IRegionResponse, IStationResponse, ITripRouteResponse } from './../model/MasterModel';
import { CustomerBlockByIdService, CustomerUnBlockByIdService, DeleteCityByIdService, DeleteCountryByIdService, DeleteEmployeeByIdService, DeleteEventByIdService, DeleteExceptionByIdService, DeleteOdaByIdService, DeleteProductByIdService, DeleteRegionByIdService, DeleteStationByIdService, DeleteTripRouteByIdService, DeleteVehicleByIdService, GetCityPageService, GetCountryPageService, GetEmployeeByIdService, GetEmployeePageService, GetEventPageService, GetExceptionPageService, GetOdaPageService, GetProductPageService, GetProductService, GetRegionPageService, GetStationByIdService, GetStationPageService, GetTripRoutePageService, GetVehicleByIdService, SaveCityService, SaveCountryService, SaveEmployeeService, SaveEventService, SaveExceptionService, SaveOdaService, SaveProductService, SaveRegionService, SaveStationService, SaveTripRouteService, SaveVehicleService, UpdateEmployeeService, UpdateStationService, UpdateVehicleService } from './../services/master-services';
import { BOX_TYPE, FIVE_HUNDRED, FOUR_HUNDRED, FOUR_HUNDRED_NINE, TRAY_TYPE, TWO_HUNDRED_SUCCESS_CODE, downloadBlob, fileFormat, removeDuplicateObjects } from './../utils/app-common';
import { CustomerUploadFormData, responseData } from "./common";
import { GetComplaintUploadFileService, GetExceptionListByCategoryIdService, GetVehicleRequestUploadFileService } from '../services/common-service';
import { convertMillisToDateMoment } from '../utils/luxon';
import { IFetchFiles, IFile } from '../model/BookingModel';
import { DeleteFileByIdService, UploadFileService } from '../services/booking-service';
import { useCustomerStore } from './CustomerStore';
import { message, notification } from 'antd';
import { PaginationParams } from '../model/CommonModel';

export const TRIP_ROUTE_FETCH_SIZE = 2000;

const initialValue: IMasterInitial = {
    exceptionList: [],
    employeeList: [],
    vehiclesList: [],
    adhocVehicles: [],
    customerList: [],
    cityList: [],
    eventList: [],
    tripRouteList: [],
    countryList: [],
    regionList: [],
    odaList: [],
    productList: [],
    countryPageList: [],
    totalNumberOfCountries: 0,
    employeePageList: [],
    nonAdhocEmployeeList: [],
    totalNonAdhocEmployees: 0,
    adhocEmployeeList: [],
    totalAdhocEmployees: 0,
    totalNumberOfEmployees: 0,
    nonAdhocVehicleList: [],
    totalNonAdhocVehicles: 0,
    adhocVehicleList: [],
    totalAdhocVehicles: 0,
    tripRoutePageList: [],
    totalNumberOfTripRoutes: 0,
    cityPageList: [],
    totalNumberOfCity: 0,
    regionPageList: [],
    totalNumberOfRegion: 0,
    productPageList: [],
    totalNumberOfProduct: 0,
    eventPageList: [],
    totalNumberOfEvent: 0,
    exceptionPageList: [],
    totalNumberOfException: 0,
    odaPageList: [],
    totalNumberOfOda: 0,
    stationPageList: [],
    totalNumberOfStation: 0,
    employeeRequestList: [],
    vehicleRequestList: [],
    stationRequestList: [],
    blockStatusResponse: undefined,
    unBlockStatusResponse: undefined,
    loggedOutResponse: undefined,
    vehiclesLoggedInDetails: [],
    totalNumberOfVehicleLogins: 0,
    categoryList: [],
    plateAndFleetList: undefined,
    shipperDeleteResponse: undefined,
    consigneeDeleteResponse: undefined,
    ownersList: [],
    vehicleTypeList: [],
    vehicleStatusList: [],
    trayBarCodes: [],
    boxesHistory: [],
    boxes: [],
    barCodesGeneratorResponse: undefined,
    employeeResponse: undefined,
    exceptionReasonList: [],
    exceptionSubReason: [],
    pagination: {},

    vehicleMakeList: [],
    vehicleModelList: [],
    vehicleBodyTypeList: [],
    vehicleLoadTypeList: [],
    vehicleBrandingList: [],
    vehicleFuelTypeList: [],
    vehiclePurchaseModeList: [],
    additionalPermitList: [],
    odometers: [],
    vehicleResponse: undefined,
    additionalPermitResponse: undefined,
    bodyTypeResponse: undefined,
    brandingResponse: undefined,
    fuelTypeResponse: undefined,
    loadTypeResponse: undefined,
    makeTypeResponse: undefined,
    ModelTypeResponse: undefined,
    ownerTypeResponse: undefined,
    purchaseModeTypeResponse: undefined,
    vehicleTypeResponse: undefined,
    vehicleGPSStatusList: [],
    uploadedFiles: [],
    vehicleLeaseTypeList: [],
    uploadedTammFiles: [],
    vehicleRequestFileTypesList: [],
    vehicleRequest: [],
    vehicleReplacementResponse: undefined,
    vehicleCreateRequestResponse: undefined,
    vehicleStatusHistoryList: [],
    uploadedVehicleRequestFiles: [],
    uploadedFilesAndTypes: [],
    uploadedVehicleRequestFileType: undefined,
    deleteFileResponse: undefined,
    otherSellerTypeList: [],
    tripRouteRequestList: [],
    tripRouteCreateRequestResponse: undefined,
}

const MasterStore = create<IMasterInterface>(((set, get) => ({
    ...initialValue,
    GetExceptionListAction: async () => {
        const response = await getExceptionListService();
        set({ exceptionList: responseData(response?.data) })
    },
    GetEmployeeListAction: async () => {
        const response = await getEmployeeListService();
        set({ employeeList: responseData(response?.data) })
    },
    GetVehiclesListAction: async () => {
        const response = await getVehicleListService();
        set({ vehiclesList: responseData(response?.data) })
    },
    GetAdhocVehiclesAction: async () => {
        const response = await getAdhocVehiclesService();
        set({ adhocVehicles: responseData(response?.data) });
    },
    GetCustomerListAction: async (pageNumber: number, pageSize: number, isFinance: boolean = false) => {
        const response = await getCustomerListService(pageNumber, pageSize, isFinance);
        const customer = response?.data?.data?.map((item: CustomerInterface) => ({
            ...item,
            blockedText: item?.blocked ? 'Blocked' : 'Not Blocked',
            cashOnly: item?.cashOnly ? 'Yes' : 'No',
            codOnly: item?.codOnly ? 'Yes' : 'No',
            isCashCustomer: item?.cashOnly,
            onAccountOnly: item?.onAccountOnly ? 'Yes' : 'No',
        }));
        set({ customerList: removeDuplicateObjects(customer, 'accountId') as CustomerInterface[] })
    },

    GetCityListAction: async () => {
        const response = await getCityListService();
        set({ cityList: responseData(response?.data) })
    },
    GetEventListAction: async () => {
        const response = await getEventListService();
        const event = response?.data.data?.map((item: EventInterface) => {
            return {
                ...item,
                isinternal: item?.isinternal ? 'Yes' : 'No',
                isboth: item?.isboth === 1 ? 'Yes' : 'No',
            }
        });
        set({ eventList: event })
    },
    GetTripRoutesListAction: async () => {
        const response = await getTripRouteListService();
        set({ tripRouteList: responseData(response?.data) })
    },
    GetCountryListAction: async () => {
        const response = await GetCountryService();
        set({ countryList: responseData(response?.data) })
    },
    GetRegionListAction: async () => {
        const response = await GetRegionService();
        set({ regionList: responseData(response?.data) })
    },
    GetOdaListAction: async () => {
        const response = await GetOdaService();
        set({ odaList: responseData(response?.data) })
    },
    GetProductAction: async () => {
        const response = await GetProductService();
        set({ productList: responseData(response?.data) })
    },
    SaveCountryAction: async (data: ICountryResponse) => {
        const response = await SaveCountryService(data);
        getNotificationStyle(response);
        get().GetCountryPageAction(0, 10);
    },
    SaveCityAction: async (data: ICityResponse) => {
        const response = await SaveCityService(data);
        getNotificationStyle(response);
        get().GetCityPageAction(0, 10)
    },
    SaveRegionAction: async (data: IRegionResponse) => {
        const response = await SaveRegionService(data);
        getNotificationStyle(response);
        get().GetRegionPageAction(0, 10)
    },
    SaveOdaAction: async (data: IOdaResponse) => {
        const response = await SaveOdaService(data);
        getNotificationStyle(response);
        get().GetOdaPageAction(0, 10)
    },
    SaveTripRouteAction: async (data: ITripRouteResponse) => {
        const response = await SaveTripRouteService(data);
        const { statusCode } = response?.data || {};
        getNotificationStyle(response);
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ tripRouteCreateRequestResponse: statusCode });
            get().GetTripRoutePageAction(0, TRIP_ROUTE_FETCH_SIZE);
        }
    },
    SaveProductAction: async (data: IProductResponse) => {
        const response = await SaveProductService(data);
        getNotificationStyle(response);
        get().GetProductPageAction(0, 10)
    },
    SaveEmployeeAction: async (data, isAdhoc, paginationParams, filterParams) => {
        const response = await SaveEmployeeService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            set({ employeeResponse: statusCode });
            isAdhoc ? get().GetAdhocEmployeeListAction(paginationParams, filterParams) : get().GetNonAdhocEmployeeListAction(paginationParams, filterParams);
        }
    },
    SaveEventAction: async (data: IEventResponse) => {
        const response = await SaveEventService(data);
        getNotificationStyle(response);
        get().GetEventPageAction(0, 10)
    },
    SaveExceptionAction: async (data: IExceptionResponse) => {
        const response = await SaveExceptionService(data);
        getNotificationStyle(response);
        get().GetExceptionPageAction(0, 10)
    },
    SaveVehicleAction: async (data, extraData) => {
        const response = await SaveVehicleService(data);
        // save files
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            const data: IVehicleRequestbyId = responseData(response?.data);
            const uploadFileList = get().uploadedFiles ?? [];
            if (uploadFileList?.length) {
                const request: IFile = {
                    wayBillNumber: undefined,
                    category: "Vehicle TGA File",
                    fileType: "Vehicle TGA File",
                    files: uploadFileList,
                    categoryId: String(data.id),
                    generic: String(true)
                }
                const { formData, configuration } = CustomerUploadFormData(request);
                trackPromise(get().UploadFileAction({ formData, configuration }), 'upload-file-area');
            }
            const uploadeTammFiles = get().uploadedTammFiles ?? [];
            if (uploadeTammFiles?.length) {
                const request: IFile = {
                    wayBillNumber: undefined,
                    category: "Vehicle Tamm File",
                    fileType: "Vehicle Tamm File",
                    files: uploadeTammFiles,
                    categoryId: String(data.id),
                    generic: String(true)
                }
                const { formData, configuration } = CustomerUploadFormData(request);
                trackPromise(get().UploadTammFileAction({ formData, configuration }), 'upload-file-area');
            }
            set({ vehicleResponse: statusCode });
            getNotificationStyle(response);
            get().ClearVehicleStoreAction();
            const { isAdhoc, current, pageSize, filterParams } = extraData || {};
            if (isAdhoc) {
                trackPromise(get().GetAdhocVehicleListAction({ current, pageSize }, filterParams), "get-adhoc-vehicles-area");
            } else {
                trackPromise(get().GetNonAdhocVehicleListAction({ current, pageSize }, filterParams), "get-non-adhoc-vehicles-area");
            }
        }
    },
    UploadFileAction: async (request: { formData: FormData, configuration: {} }) => {
        const response = await UploadFileService(request);
        const { statusCode } = response?.data ?? {};
        if (statusCode !== TWO_HUNDRED_SUCCESS_CODE) getNotificationStyle(response)
        set({ uploadedFiles: [] })
    },
    UploadTammFileAction: async (request: { formData: FormData, configuration: {} }) => {
        const response = await UploadFileService(request);
        const { statusCode } = response?.data ?? {};
        if (statusCode !== TWO_HUNDRED_SUCCESS_CODE) getNotificationStyle(response)
        set({ uploadedTammFiles: [] })
    },
    UploadFileState: (files: [] = []) => {
        set({
            uploadedFiles: [
                ...files]
        });
    },
    UploadTammFileState: (files: [] = []) => {
        set({
            uploadedTammFiles: [
                ...files]
        });
    },
    DeleteUploadFileState: (files: any = {}) => {
        const list: any[] = get().uploadedFiles ?? [];
        const filtered = list?.filter(item => item?.uid !== files?.uid);
        set({ uploadedFiles: filtered });
    },
    DeleteTammUploadFileState: (files: any = {}) => {
        const list: any[] = get().uploadedTammFiles ?? [];
        const filtered = list?.filter(item => item?.uid !== files?.uid);
        set({ uploadedTammFiles: filtered });
    },
    ClearUploadedVehicleFileList: () => set({ uploadedFiles: [], uploadedTammFiles: [] }),
    GetVehicleUploadFileAction: async (request: IFetchFiles) => {
        const response = await GetComplaintUploadFileService(request);
        const { statusCode } = response?.data || {};
        if (statusCode !== TWO_HUNDRED_SUCCESS_CODE) getNotificationStyle(response);
        set({ uploadedFiles: responseData(response?.data) });
    },
    GetVehicleTammUploadFileAction: async (request: IFetchFiles) => {
        const response = await GetComplaintUploadFileService(request);
        const { statusCode } = response?.data || {};
        if (statusCode !== TWO_HUNDRED_SUCCESS_CODE) getNotificationStyle(response);
        set({ uploadedTammFiles: responseData(response?.data) });
    },
    SaveStationAction: async (data: IStationResponse) => {
        const response = await SaveStationService(data);
        getNotificationStyle(response);
        get().GetStationPageAction(0, 10);
    },
    DeleteCountryByIdAction: async (id: number | undefined) => {
        const response = await DeleteCountryByIdService(id);
        getNotificationStyle(response);
        get().GetCountryPageAction(0, 10)
    },

    DeleteRegionByIdAction: async (id: number | undefined) => {
        const response = await DeleteRegionByIdService(id);
        getNotificationStyle(response);
        get().GetRegionPageAction(0, 10)
    },

    DeleteProductByIdAction: async (id: number | undefined) => {
        const response = await DeleteProductByIdService(id);
        getNotificationStyle(response);
        get().GetProductPageAction(0, 10)
    },
    DeleteOdaByIdAction: async (id: number | undefined) => {
        const response = await DeleteOdaByIdService(id);
        getNotificationStyle(response);
        get().GetOdaPageAction(0, 10)
    },
    DeleteExceptionByIdAction: async (id: number | undefined) => {
        const response = await DeleteExceptionByIdService(id);
        getNotificationStyle(response);
        get().GetExceptionPageAction(0, 10)
    },
    DeleteEventByIdAction: async (id: number | undefined) => {
        const response = await DeleteEventByIdService(id);
        getNotificationStyle(response);
        get().GetEventPageAction(0, 10)
    },
    DeleteCityByIdAction: async (id: number | undefined) => {
        const response = await DeleteCityByIdService(id);
        getNotificationStyle(response);
        get().GetCityPageAction(0, 10)
    },
    DeleteTripRouteByIdAction: async (id: number | undefined) => {
        const response = await DeleteTripRouteByIdService(id);
        getNotificationStyle(response);
        trackPromise(get().GetTripRoutePageAction(0, TRIP_ROUTE_FETCH_SIZE), 'triproute-list-area')
    },
    DeleteVehicleByIdAction: async (id: number | undefined) => {
        const response = await DeleteVehicleByIdService(id);
        getNotificationStyle(response);
    },
    DeleteEmployeeByIdAction: async (id: number | undefined) => {
        const response = await DeleteEmployeeByIdService(id);
        getNotificationStyle(response);
        get().GetEmployeePageAction(0, 10)
    },
    DeleteStationByIdAction: async (id: number | undefined) => {
        const response = await DeleteStationByIdService(id);
        getNotificationStyle(response);
        get().GetStationPageAction(0, 10)
    },
    GetCountryPageAction: async (pageNumber: number, pageSize: number) => {
        const response = await GetCountryPageService(pageNumber, pageSize);
        set({ countryPageList: responseData(response?.data) })
        set({ totalNumberOfCountries: response?.data.totalNumberOfAllElements })
    },
    GetEmployeePageAction: async (pageNumber: number, pageSize: number) => {
        const response = await GetEmployeePageService(pageNumber, pageSize);
        const { totalPages, isLast, numberOfElements, page, totalNumberOfAllElements } = response?.data || {};
        set({ employeePageList: responseData(response?.data), pagination: { totalPages, isLast, numberOfElements, page, totalNumberOfAllElements } });

        //set({ totalNumberOfEmployees: response?.data.totalNumberOfAllElements })
    },
    GetNonAdhocEmployeeListAction: async (paginationParams, filterParams) => {
        const response = await GetNonAdhocEmployeesService(paginationParams, filterParams);
        set({ nonAdhocEmployeeList: responseData(response?.data) || [] });
        set({ totalNonAdhocEmployees: response?.data?.totalNumberOfAllElements ?? 0 })
    },
    GetAdhocEmployeeListAction: async (paginationParams, filterParams) => {
        const response = await GetAdhocEmployeesService(paginationParams, filterParams);
        set({ adhocEmployeeList: responseData(response?.data) || [] });
        set({ totalAdhocEmployees: response?.data?.totalNumberOfAllElements ?? 0 })
    },
    GetNonAdhocVehicleListAction: async (paginationParams, filterParams) => {
        const response = await GetNonAdhocVehiclesService(paginationParams, filterParams);
        set({ nonAdhocVehicleList: responseData(response?.data) || [] });
        set({ totalNonAdhocVehicles: response?.data?.totalNumberOfAllElements ?? 0 })
    },
    GetAdhocVehicleListAction: async (paginationParams, filterParams) => {
        const response = await GetAdhocVehiclesService(paginationParams, filterParams);
        set({ adhocVehicleList: responseData(response?.data) || [] });
        set({ totalAdhocVehicles: response?.data?.totalNumberOfAllElements ?? 0 })
    },
    GetTripRoutePageAction: async (pageNumber: number, pageSize: number) => {
        const response = await GetTripRoutePageService(pageNumber, pageSize);
        set({ tripRoutePageList: responseData(response?.data) })
        set({ totalNumberOfTripRoutes: response?.data.totalNumberOfAllElements })
    },
    GetCityPageAction: async (pageNumber: number, pageSize: number) => {
        const response = await GetCityPageService(pageNumber, pageSize);
        set({ cityPageList: responseData(response?.data) })
        set({ totalNumberOfCity: response?.data.totalNumberOfAllElements })
    },
    GetRegionPageAction: async (pageNumber: number, pageSize: number) => {
        const response = await GetRegionPageService(pageNumber, pageSize);
        set({ regionPageList: responseData(response?.data) })
        set({ totalNumberOfRegion: response?.data.totalNumberOfAllElements })
    },
    GetProductPageAction: async (pageNumber: number, pageSize: number) => {
        const response = await GetProductPageService(pageNumber, pageSize);
        set({ productPageList: responseData(response?.data) })
        set({ totalNumberOfProduct: response?.data.totalNumberOfAllElements })
    },
    GetEventPageAction: async (pageNumber: number, pageSize: number) => {
        const response = await GetEventPageService(pageNumber, pageSize);
        set({ eventPageList: responseData(response?.data) })
        set({ totalNumberOfEvent: response?.data.totalNumberOfAllElements })
    },
    GetExceptionPageAction: async (pageNumber: number, pageSize: number) => {
        const response = await GetExceptionPageService(pageNumber, pageSize);
        set({ exceptionPageList: responseData(response?.data) })
        set({ totalNumberOfException: response?.data.totalNumberOfAllElements })
    },
    GetExceptionSubReasonAction: async (exceptionId: number) => {
        const response = await GetExceptionSubReasonService(exceptionId);
        set({ exceptionSubReason: responseData(response?.data) })
        //  set({ totalNumberOfException: response?.data.totalNumberOfAllElements })
    },
    GetOdaPageAction: async (pageNumber: number, pageSize: number) => {
        const response = await GetOdaPageService(pageNumber, pageSize);
        set({ odaPageList: responseData(response?.data) })
        set({ totalNumberOfOda: response?.data.totalNumberOfAllElements })
    },
    GetStationPageAction: async (pageNumber: number, pageSize: number) => {
        const response = await GetStationPageService(pageNumber, pageSize);
        set({ stationPageList: responseData(response?.data) })
        set({ totalNumberOfStation: response?.data.totalNumberOfAllElements })
    },
    GetEmployeeByIdAction: async (id: number) => {
        const response = await GetEmployeeByIdService(id);
        set({ employeeRequestList: responseData(response?.data) })
    },
    GetVehicleByIdAction: async (id: number) => {
        const response = await GetVehicleByIdService(id);
        set({ vehicleRequestList: [] });
        const item = responseData(response?.data);
        const modifiedResponse = Object.assign({}, item, {
            contractStartDate: item?.contractStartDate === undefined ? undefined : convertMillisToDateMoment(item?.contractStartDate),
            contractExpiryDate: item?.contractExpiryDate === undefined ? undefined : convertMillisToDateMoment(item?.contractExpiryDate),
            istimarahExpiryDate: item?.istimarahExpiryDate === undefined ? undefined : convertMillisToDateMoment(item?.istimarahExpiryDate),
            mvpiExpiryDate: item?.mvpiExpiryDate === undefined ? undefined : convertMillisToDateMoment(item?.mvpiExpiryDate),
            motExpiryDate: item?.motExpiryDate === undefined ? undefined : convertMillisToDateMoment(item?.motExpiryDate),
            insuranceExpiryDate: item?.insuranceExpiryDate === undefined ? undefined : convertMillisToDateMoment(item?.insuranceExpiryDate),
            vehicleDetailDto: Object.assign({}, item?.vehicleDetailDto, {
                purchaseDate: item?.vehicleDetailDto?.purchaseDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.purchaseDate),
                purchaseOrderDate: item?.vehicleDetailDto?.purchaseOrderDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.purchaseOrderDate),
                operationStartDate: item?.vehicleDetailDto?.operationStartDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.operationStartDate),
                leaseReplacementUnitDate: item?.vehicleDetailDto?.leaseReplacementUnitDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.leaseReplacementUnitDate),
                leaseEarlyRetrunDate: item?.vehicleDetailDto?.leaseEarlyRetrunDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.leaseEarlyRetrunDate),
                insuranceIssueDate: item?.vehicleDetailDto?.insuranceIssueDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.insuranceIssueDate),
                istimaraIssueDate: item?.vehicleDetailDto?.istimaraIssueDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.istimaraIssueDate),
                motIssueDate: item?.vehicleDetailDto?.motIssueDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.motIssueDate),
                mvpiIssueDate: item?.vehicleDetailDto?.mvpiIssueDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.mvpiIssueDate),
                lastAuditDate: item?.vehicleDetailDto?.lastAuditDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.lastAuditDate),
                dlExpiryDate: item?.vehicleDetailDto?.dlExpiryDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.dlExpiryDate),
                issueDate: item?.vehicleDetailDto?.issueDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.issueDate),
                returnDate: item?.vehicleDetailDto?.returnDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.returnDate),
                additionalPermitExpiryDate: item?.vehicleDetailDto?.additionalPermitExpiryDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.additionalPermitExpiryDate),
                lastAuditStatus: item?.vehicleDetailDto?.lastAuditStatus === undefined ? undefined : Number(item?.vehicleDetailDto?.lastAuditStatus),
                isGPSInstalled: item?.vehicleDetailDto?.isGPSInstalled === undefined ? undefined : Number(item?.vehicleDetailDto?.isGPSInstalled),
                isTailGate: item?.vehicleDetailDto?.isTailGate === undefined ? undefined : Number(item?.vehicleDetailDto?.isTailGate),
                isTgaCardAvailable: item?.vehicleDetailDto?.isTgaCardAvailable === undefined ? undefined : Number(item?.vehicleDetailDto?.isTgaCardAvailable),
                tgaCardIssueDate: item?.vehicleDetailDto?.tgaCardIssueDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.tgaCardIssueDate),
                tgaCardExpiryDate: item?.vehicleDetailDto?.tgaCardExpiryDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.tgaCardExpiryDate),
                isAdhoc: item?.vehicleDetailDto?.isAdhoc === undefined ? undefined : Boolean(item?.vehicleDetailDto?.isAdhoc),
                arabicReplacedPlateNumber: item?.vehicleDetailDto?.arabicReplacedPlateNumber,

                isTammAuthAvailable: item?.vehicleDetailDto?.isTammAuthAvailable === undefined ? undefined : Number(item?.vehicleDetailDto?.isTammAuthAvailable),
                tammAuthIssueDate: item?.vehicleDetailDto?.tammAuthIssueDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.tammAuthIssueDate),
                tammAuthExpiryDate: item?.vehicleDetailDto?.tammAuthExpiryDate === undefined ? undefined : convertMillisToDateMoment(item?.vehicleDetailDto?.tammAuthExpiryDate),
            })
        });
        set({ vehicleRequestList: modifiedResponse });
    },
    UpdateEmployeeAction: async (id, data, isAdhoc, paginationParams, filterParams) => {
        const response = await UpdateEmployeeService(id, data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            set({ employeeResponse: statusCode });
            isAdhoc ? get().GetAdhocEmployeeListAction(paginationParams, filterParams) : get().GetNonAdhocEmployeeListAction(paginationParams, filterParams);
        }
    },
    UpdateVehicleAction: async (id, data, extraData) => {
        const response = await UpdateVehicleService(id, data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            const uploadFileList = get().uploadedFiles ?? [];
            if (uploadFileList?.length) {
                const request: IFile = {
                    wayBillNumber: undefined,
                    category: "Vehicle TGA File",
                    fileType: "Vehicle TGA File",
                    files: uploadFileList,
                    categoryId: String(id),
                    generic: String(true)
                }

                const check = uploadFileList?.find((item: any) => item?.originFileObj != undefined);
                if (check !== undefined) {
                    const { formData, configuration } = CustomerUploadFormData(request);
                    trackPromise(get().UploadFileAction({ formData, configuration }), 'upload-file-area');
                }
            }
            const uploadedTammFiles = get().uploadedTammFiles ?? [];
            if (uploadedTammFiles?.length) {
                const request: IFile = {
                    wayBillNumber: undefined,
                    category: "Vehicle Tamm File",
                    fileType: "Vehicle Tamm File",
                    files: uploadedTammFiles,
                    categoryId: String(id),
                    generic: String(true)
                }

                const check = uploadedTammFiles?.find((item: any) => item?.originFileObj != undefined);
                if (check !== undefined) {
                    const { formData, configuration } = CustomerUploadFormData(request);
                    trackPromise(get().UploadTammFileAction({ formData, configuration }), 'upload-file-area');
                }
            }
            getNotificationStyle(response);
            get().ClearVehicleStoreAction();
            const { isAdhoc, current, pageSize, filterParams } = extraData || {};
            if (isAdhoc) {
                trackPromise(get().GetAdhocVehicleListAction({ current, pageSize }, filterParams), "get-adhoc-vehicles-area");
            } else {
                trackPromise(get().GetNonAdhocVehicleListAction({ current, pageSize }, filterParams), "get-non-adhoc-vehicles-area");
            }
        }
    },
    GetStationByIdAction: async (id: number) => {
        const response = await GetStationByIdService(id);
        set({ stationRequestList: responseData(response?.data) })
    },
    UpdateStationAction: async (id: number | undefined, data: IStationResponse) => {
        const response = await UpdateStationService(id, data);
        getNotificationStyle(response);
    },
    CustomerBlockByIdAction: async (request: IBlockRequest, id: number | undefined) => {
        const response = await CustomerBlockByIdService(id, request);
        const { statusCode } = response?.data || {};

        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ blockStatusResponse: statusCode });
            getNotificationStyle({ ...response });
            trackPromise(get().GetCustomerListAction(1, 100), 'customer-list-area')
        }
    },
    CustomerUnBlockByIdAction: async (id: number | undefined) => {
        const response = await CustomerUnBlockByIdService(id);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ unBlockStatusResponse: statusCode });
            getNotificationStyle({ ...response });
            trackPromise(get().GetCustomerListAction(1, 100), 'customer-list-area')
        }
    },
    SubAccountBlockByIdAction: async (request: IBlockRequest, subClientId: number, clientId: number, GetCustomerSubAccountAction: (clientId: number) => Promise<void>) => {
        const response = await SubAccountBlockByIdService(subClientId, request);
        const { statusCode } = response?.data || {};

        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ blockStatusResponse: statusCode });
            getNotificationStyle({ ...response });
            trackPromise(GetCustomerSubAccountAction(clientId), 'customer-sub-account-area');
        }
    },
    GetVehiclesLoggedInDetailsAction: async (pageNumber: number, pageSize: number) => {
        const response = await GetVehiclesLoggedInDetailsService(pageNumber, pageSize);
        set({ vehiclesLoggedInDetails: responseData(response?.data) })
        set({ totalNumberOfVehicleLogins: response?.data.totalNumberOfAllElements })
    },
    UpdateVehiclesLoggedInDetailsAction: async (id: number | undefined) => {
        const response = await UpdateVehiclesLoggedInDetailsService(id);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ loggedOutResponse: statusCode });
            getNotificationStyle({ ...response });
            trackPromise(get().GetVehiclesLoggedInDetailsAction(0, 10), 'vehicle-list-area');
        }
    },
    ActivateByIdAction: async (id: number | undefined, isActive: number | undefined, extraData: IExtraData) => {
        const response = await ActivateByIdService(id, isActive);
        getNotificationStyle(response);
        const { isAdhoc, current, pageSize } = extraData || {};
        if (isAdhoc) {
            trackPromise(get().GetAdhocVehicleListAction({ current, pageSize }), "get-adhoc-vehicles-area");
        } else {
            trackPromise(get().GetNonAdhocVehicleListAction({ current, pageSize }), "get-non-adhoc-vehicles-area");
        }
    },
    ExportAdhocVehiclesAction: async () => {
        const response = await ExportAdhocVehiclesService();
        const { fileName, fileType, file } = responseData(response?.data);
        downloadBlob(file, fileName, fileFormat[fileType]);
    },
    ExportNonAdhocVehiclesAction: async () => {
        const response = await ExportNonAdhocVehiclesService();
        const { fileName, fileType, file } = responseData(response?.data);
        downloadBlob(file, fileName, fileFormat[fileType]);
    },
    GetCategoryListAction: async () => {
        const response = await GetCategoryListService();
        set({ categoryList: responseData(response?.data) })
    },
    GetPlateAndFleetListAction: async () => {
        const response = await GetPlateAndFleetListService();
        set({ plateAndFleetList: responseData(response?.data) })
    },
    ExportEmployeeAction: async () => {
        const response = await ExportEmployeeService();
        const { fileName, fileType, file } = responseData(response?.data);
        downloadBlob(file, fileName, fileFormat[fileType]);
    },
    ExportNonAdhocEmployeeAction: async () => {
        const response = await ExportNonAdhocEmployeeService();
        const { fileName, fileType, file } = responseData(response?.data);
        downloadBlob(file, fileName, fileFormat[fileType]);
    },
    ExportAdhocEmployeeAction: async () => {
        const response = await ExportAdhocEmployeeService();
        const { fileName, fileType, file } = responseData(response?.data);
        downloadBlob(file, fileName, fileFormat[fileType]);
    },
    GetOwnerListAction: async () => {
        const response = await GetOwnerListService();
        set({ ownersList: responseData(response?.data) })
    },
    GetVehicleTypeListAction: async () => {
        const response = await GetVehicleTypeListService();
        set({ vehicleTypeList: responseData(response?.data) })
    },
    GetVehicleStatusListAction: async () => {
        const response = await GetVehicleStatusListService();
        let modified: IVehicleStatus[] = responseData(response?.data);
        modified = modified?.filter(item => (item?.id !== 2))
        set({ vehicleStatusList: modified })
    },
    SaveOwnerAction: async (data: IOwnerRequest) => {
        const response = await SaveOwnerService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ ownerTypeResponse: statusCode });
            getNotificationStyle(response);
            get().GetOwnerListAction()
        }
    },
    SaveVehicleTypeAction: async (data: IVehicleTypeRequest) => {
        const response = await SaveVehicleTypeService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ vehicleTypeResponse: statusCode });
            getNotificationStyle(response);
            get().GetVehicleTypeListAction()
        }
    },
    DeleteShipperByIdAction: async (id: number | undefined) => {
        const response = await DeleteShipperByIdService(id);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            set({ shipperDeleteResponse: statusCode })
        }
    },
    DeleteConsigneeByIdAction: async (id: number | undefined) => {
        const response = await DeleteConsigneeByIdService(id);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            set({ consigneeDeleteResponse: statusCode })
        }
    },
    GetListOfTrayBarCodesAction: async () => {
        const response = await GetListOfTrayBarCodesService();
        set({ trayBarCodes: responseData(response?.data) })
    },
    GetBoxesHistoryByIdAction: async (id: number | undefined) => {
        const response = await GetBoxesHistoryByIdService(id);
        set({ boxesHistory: responseData(response?.data) })
    },
    GetListOfBoxesAction: async () => {
        const response = await GetListOfBoxesService();
        set({ boxes: responseData(response?.data) })
    },

    SaveBarCodeGeneratorAction: async (request: ICodeGenerator, type: string) => {
        const response = await SaveBarCodeGeneratorService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            set({ barCodesGeneratorResponse: statusCode });
            if (type === BOX_TYPE) {
                trackPromise(get().GetListOfBoxesAction(), 'boxes-area')
                return;
            }
            if (type === TRAY_TYPE) {
                trackPromise(get().GetListOfTrayBarCodesAction(), 'tray-boxes-area')
                return;
            }
        }
    },
    FilterExceptionListByCategoryIdAction: async (id: number | undefined) => {
        const response = await GetExceptionListByCategoryIdService(id);
        const event = response?.data.data?.map((item: any) => {
            return {
                exceptionId: item?.id,
                exception: item?.name,
                exceptionAr: item?.nameAr,
                exceptionCode: item?.code,
                exceptionCategoryId: item?.exceptionCategoryId,
                exceptionCategory: item?.exceptionCategoryName,
                business: item?.businessName,
                division: item?.divisionName,
                status: item?.status,
            }
        });

        set({ exceptionPageList: event })
    },
    DeActivateExceptionByIdAction: async (id: number | undefined) => {
        const response = await DeActivateExceptionByIdService(id);
        getNotificationStyle(response);
        get().GetExceptionPageAction(0, 10)
    },
    DeActivateEmployeeByIdAction: async (id: number | undefined) => {
        const response = await DeActivateEmployeeByIdService(id);
        getNotificationStyle(response);
        get().GetEmployeePageAction(0, 10)
    },
    SearchEmployeeAction: async (request: ISearchEmployeeRequest) => {
        const response = await SearchEmployeeService(request);
        set({ nonAdhocEmployeeList: responseData(response?.data) || [] });
        set({ totalNonAdhocEmployees: responseData(response?.data)?.length ?? 0 })
    },

    GetVehicleMakeListAction: async () => {
        const response = await GetVehicleMakeListService();
        set({ vehicleMakeList: responseData(response?.data) })
    },

    GetVehicleModelListAction: async () => {
        const response = await GetVehicleModelListService();
        set({ vehicleModelList: responseData(response?.data) })
    },
    GetVehicleLoadTypeListAction: async () => {
        const response = await GetVehicleLoadTypeListService();
        set({ vehicleLoadTypeList: responseData(response?.data) })
    },
    GetVehicleBodyTypeListAction: async () => {
        const response = await GetVehicleBodyTypeListService();
        set({ vehicleBodyTypeList: responseData(response?.data) })
    },
    GetVehicleBrandingListAction: async () => {
        const response = await GetVehicleBrandingListService();
        set({ vehicleBrandingList: responseData(response?.data) })
    },
    GetVehicleFuelTypeListAction: async () => {
        const response = await GetVehicleFuelTypeListService();
        set({ vehicleFuelTypeList: responseData(response?.data) })
    },
    GetVehiclePurchaseModeListAction: async () => {
        const response = await GetVehiclePurchaseModeListService();
        set({ vehiclePurchaseModeList: responseData(response?.data) })
    },
    GetAdditonalPermitListAction: async () => {
        const response = await GetAdditonalPermitListService();
        set({ additionalPermitList: responseData(response?.data) })
    },

    SaveVehicleMakeAction: async (data: IOwnerRequest) => {
        const response = await SaveVehicleMakeService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ makeTypeResponse: statusCode });
            getNotificationStyle(response);
            get().GetVehicleMakeListAction()
        }

    },
    SaveVehicleModelAction: async (data: IOwnerRequest) => {
        const response = await SaveVehicleModelService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ ModelTypeResponse: statusCode });
            getNotificationStyle(response);
            get().GetVehicleModelListAction()
        }

    },
    SaveVehicleLoadTypeAction: async (data: IOwnerRequest) => {
        const response = await SaveVehicleLoadTypeService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ loadTypeResponse: statusCode });
            getNotificationStyle(response);
            get().GetVehicleLoadTypeListAction()
        }
    },
    SaveVehicleBodyTypeAction: async (data: IOwnerRequest) => {
        const response = await SaveVehicleBodyTypeService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ bodyTypeResponse: statusCode });
            getNotificationStyle(response);
            get().GetVehicleBodyTypeListAction()
        }
    },
    SaveVehicleBrandingAction: async (data: IOwnerRequest) => {
        const response = await SaveVehicleBrandingService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ brandingResponse: statusCode });
            getNotificationStyle(response);
            get().GetVehicleBrandingListAction()
        }
    },
    SaveVehicleFuelTypeAction: async (data: IOwnerRequest) => {
        const response = await SaveVehicleFuelTypeService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ fuelTypeResponse: statusCode });
            getNotificationStyle(response);
            get().GetVehicleFuelTypeListAction()
        }

    },
    SaveVehiclePurchaseModeAction: async (data: IOwnerRequest) => {
        const response = await SaveVehiclePurchaseModeService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ purchaseModeTypeResponse: statusCode });
            getNotificationStyle(response);
            get().GetVehiclePurchaseModeListAction()
        }

    },
    SaveAdditonalPermitAction: async (data: IOwnerRequest) => {
        const response = await SaveAdditonalPermitService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ additionalPermitResponse: statusCode });
            getNotificationStyle(response);
            get().GetAdditonalPermitListAction()
        }
    },
    GetOdometersAction: async (id: number) => {
        const response = await GetOdometerByIdService(id);
        set({ odometers: responseData(response?.data) })
    },
    GetVehicleGPSStatusListAction: async () => {
        const response = await GetVehicleGPSStatusListService();
        set({ vehicleGPSStatusList: responseData(response?.data) })
    },
    GetVehicleLeaseTypeListAction: async () => {
        const response = await GetVehicleLeaseTypeListService();
        set({ vehicleLeaseTypeList: responseData(response?.data) })
    },
    SaveAuthDataAction: async (data: IAuthDataRequest) => {
        const response = await SaveAuthDataService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
        }
        else if (response?.status === FOUR_HUNDRED || response?.status === FIVE_HUNDRED) {
            getNotificationStyle({ message: "Please avoid using the previous password for updates or the same username for new accounts." });
        }
        else if (response?.status === FOUR_HUNDRED_NINE || response?.status === FIVE_HUNDRED) {
            getNotificationStyle({ message: "Duplicate username or email ID" });
        }
        else {
            getNotificationStyle(response);
        }
        return response;
    },

    SaveVehicleReplacementAction: async (data: any, id: number) => {
        const response = await SaveVehicleReplacementService(data, id);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            // set({ vehicleReplacementResponse: statusCode });
            getNotificationStyle(response);
            // get().GetVehicleTypeListAction() ????????
        }
    },
    GetVehicleRequestFilesTypesListAction: async () => {
        const response = await GetVehicleRequestFilesTypesListService();
        set({ vehicleRequestFileTypesList: responseData(response?.data) })
    },
    CreateRequestAction: async (id, data, fileType) => {


        const validateUploadedFileList = get()?.uploadedVehicleRequestFiles === undefined ? undefined :
            get()?.uploadedVehicleRequestFiles?.find(item => item?.name !== undefined);


        if (fileType !== undefined && fileType !== null && fileType !== '' && !(validateUploadedFileList)) {
            notification.open({
                message: 'File type is selected but File is not uploaded',
                style: {
                    color: 'rgba(0, 0, 0, 0.65)',
                    border: '1px solid #ffa39e',
                    backgroundColor: '#fff1f0'
                },
            });
            return;
        }

        const response = await CreateRequestService(id, data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            const uploadFileList = get().uploadedVehicleRequestFiles ?? [];
            if (uploadFileList?.length) {
                uploadFileList.forEach(item => {

                    if (item?.name !== undefined) {
                        let request: IFile = {
                            wayBillNumber: undefined,
                            category: "Vehicle Request",
                            fileType: String(item?.fileType),
                            files: new Array(item),
                            categoryId: String(id),
                            generic: String(true)
                        }
                        let { formData, configuration } = CustomerUploadFormData(request);
                        trackPromise(get().UploadFileAction({ formData, configuration }), 'upload-file-area');
                    }
                });
            }
            set({ vehicleCreateRequestResponse: statusCode });
        }
        getNotificationStyle(response);
        trackPromise(get().GetNonAdhocVehicleListAction({ current: 0, pageSize: 10 }, undefined), "get-non-adhoc-vehicles-area");

    },
    GetRequestByIdAction: async (id: number) => {
        const response = await GetRequestByIdService(id);
        set({ vehicleRequest: responseData(response?.data) })
    },
    GetVehicleStatusByIdAction: async (id: number) => {
        const response = await GetVehicleStatusByIdService(id);
        set({ vehicleStatusHistoryList: responseData(response?.data) })
    },
    UploadVehicleRequestFileState: (files: [] = [], id: string | undefined) => {
        set({
            uploadedVehicleRequestFiles: [
                ...files]
        });
        set({ uploadedVehicleRequestFileType: id });
    },
    DeleteVehicleRequestFileState: (files: any = {}) => {
        const list: any[] = get().uploadedVehicleRequestFiles ?? [];
        const filtered = list?.filter(item => item?.uid !== files?.uid);
        set({ uploadedVehicleRequestFiles: filtered });
    },
    GetVehicleRequestUploadFileAction: async (request: IFetchFiles) => {
        const response = await GetVehicleRequestUploadFileService(request);
        const { statusCode } = response?.data || {};
        if (statusCode !== TWO_HUNDRED_SUCCESS_CODE) getNotificationStyle(response);
        set({ uploadedVehicleRequestFiles: responseData(response?.data) });
    },

    DeleteVehicleRequestFileByIdAction: async (id: number, request: IFetchFiles) => {
        const response = await DeleteFileByIdService(id);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            get().GetVehicleRequestUploadFileAction(request);
            set({ deleteFileResponse: statusCode });
        }
    },
    getOtherSellerTypeListAction: async () => {
        const response = await getOtherSellerTypeListService();
        set({ otherSellerTypeList: responseData(response?.data) })
    },



    GetTripRouteByIdAction: async (id: number) => {
        const response = await GetTripRouteByIdService(id);
        set({ tripRouteRequestList: responseData(response?.data) })
    },

    ExportTripRoutesExcelAction: async () => {
        const response = await ExportTripRoutesExcelService();
        const { fileName, fileType, file } = responseData(response?.data);
        downloadBlob(file, fileName, fileFormat[fileType]);
    },


    ClearVehicleStoreAction: async () => set({ vehicleRequestList: [] })
})))

export const useMasterStore = (MasterStore)